export default __webpack_public_path__ + "static/media/newspapercutting-342x342.ab420b25.jpg";